// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2VH40","errorLogs":"styles_errorLogs__3ttni"};